import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';

import { VendorDetails, VendorMenuItem } from '../../../core/models/vendor-details.model';

@Component({
  selector: 'app-vendor-menu-groups',
  templateUrl: './vendor-menu-groups.component.html',
  styleUrls: ['./vendor-menu-groups.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VendorMenuGroupsComponent implements AfterViewInit {
  @Input()
  public quickAddToCart: boolean;

  @Input()
  public vendorDetails: VendorDetails;

  @Output()
  public menuItemSelected = new EventEmitter<{ menuItem: VendorMenuItem; groupId: number }>();

  @Output()
  public menuItemDecremented = new EventEmitter<{ menuItem: VendorMenuItem; groupId: number }>();

  @Output()
  public menuItemIncremented = new EventEmitter<{ menuItem: VendorMenuItem; groupId: number }>();

  @Output()
  public menuItemAvailabilityRequested = new EventEmitter<{ menuItem: VendorMenuItem; groupId: number }>();

  @Output()
  public menuGroupsRendered = new EventEmitter<Array<HTMLElement>>();

  @ViewChildren('group')
  public groups: QueryList<ElementRef<HTMLElement>>;

  ngAfterViewInit() {
    if (this.groups?.length) {
      this.menuGroupsRendered.next(this.groups.toArray().map((elementRef) => elementRef.nativeElement));
    }
  }

  public onMenuItemSelected(menuItem: VendorMenuItem, groupId: number): void {
    this.menuItemSelected.emit({ menuItem, groupId });
  }

  public onMenuItemDecremented(menuItem: VendorMenuItem, groupId: number): void {
    this.menuItemDecremented.emit({ menuItem, groupId });
  }

  public onMenuItemIncremented(menuItem: VendorMenuItem, groupId: number): void {
    this.menuItemIncremented.emit({ menuItem, groupId });
  }

  public onMenuItemAvailabilityRequested(menuItem: VendorMenuItem, groupId: number): void {
    this.menuItemAvailabilityRequested.emit({ menuItem, groupId });
  }
}
